import { render } from "./LiveView.vue?vue&type=template&id=5ea4664f&scoped=true"
import script from "./LiveView.vue?vue&type=script&lang=js"
export * from "./LiveView.vue?vue&type=script&lang=js"

import "./LiveView.vue?vue&type=style&index=0&id=5ea4664f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea4664f"]])

export default __exports__